module.exports = __webpack_public_path__ + "static/NB-LOGO-2c1a9ecc6c18b9e60d26f40e46ff39c3.svg";